import type { seatSlots } from "./seatOrder";

export type SeatSlot = keyof ReturnType<typeof seatSlots>;

/**
 * Where a seat's card opens on the table (review 0017 U2): towards the middle, so it never
 * leaves the canvas and never covers the pod it belongs to. Pure; the pod positions it.
 */
export function cardSide(slot: SeatSlot): "above" | "below" | "left" | "right" {
  if (slot === "seatSelf") return "above";
  if (slot === "seatTop") return "below";
  return slot === "seatLeft" ? "right" : "left";
}

/** The card's offset from its pod's circle, in canvas pixels, for each side. */
export function cardStyle(
  side: ReturnType<typeof cardSide>,
  gap: number,
): Record<string, string | number> {
  if (side === "above")
    return { bottom: `calc(100% + ${gap}px)`, left: "50%", transform: "translateX(-50%)" };
  if (side === "below")
    return { top: `calc(100% + ${gap}px)`, left: "50%", transform: "translateX(-50%)" };
  const across = { top: "50%", transform: "translateY(-50%)" };
  return side === "right"
    ? { ...across, left: `calc(100% + ${gap}px)` }
    : { ...across, right: `calc(100% + ${gap}px)` };
}
